import context from '../context'
import getComponentKey from '@/utils/getComponentKey'

const pageCount = 10

const initialState = {
  read: false,
  notifications: [],
  notificationsFull: [],
  unreadCount: null,
  userNotificationCount: 0,
  page: 0,
  retrieving: false,
  retrievingFull: false,
  widgetKey: getComponentKey()
}

const actionTypes = {
  NotificationsLoaded: 'notifications/NotificationsLoaded',
  NotificationsLoadedMore: 'notifications/NotificationsLoadedMore',
  NewNotification: 'notifications/NewNotification',
  NotificationRead: 'notifications/NotificationRead',
  UpdateState: 'notifications/UpdateState',
  NotificationsClear: 'notifications/NotificationsClear',
  NotificationsLoading: 'notifications/NotificationsLoading',
  NotificationsLoadingMore: 'notifications/NotificationsLoadingMore',
  Error: 'notifications/error',
  NotificationsRead: 'notifications/NotificationsRead'
}

export const actionCreators = {
  loadNotifications: (top, asRead) => (dispatch, getState) => {
    setTimeout(async () => {
      const s = getState().notifications
      dispatch({ type: actionTypes.NotificationsLoading })
      try {
        const resp = await context.api.notificationService.getNotifications(undefined, 0, top, s.read)
        await dispatch({ type: actionTypes.NotificationsLoaded, data: resp })
      } catch (e) {
        await dispatch({ type: actionTypes.Error })
      }
    }, 200)
  },
  loadMoreNotifications: (page, asRead) => (dispatch, getState) => {
    setTimeout(() => {
      const s = getState().notifications
      if (s.retrievingFull) return
      dispatch({ type: actionTypes.NotificationsLoadingMore, page })
      context.api.notificationService.getNotifications(undefined, page * pageCount, pageCount, s.read).then(response => {
        dispatch({ type: actionTypes.NotificationsLoadedMore, data: response })
      }).catch(() => dispatch({ type: actionTypes.Error }))
    }, 200)
  },
  newNotification: (notification) => {
    return { type: actionTypes.NewNotification, data: notification }
  },
  updateState: (id, state) => (dispatch) => {
    context.api.notificationService.updateState(state, id)
      .then(() => {
        dispatch({ type: actionTypes.UpdateState, id, state })
      })
      .catch(() => dispatch({ type: actionTypes.Error }))
  },
  notificationsClear: () => (dispatch) => {
    dispatch({ type: actionTypes.NotificationsClear })
  },
  read: () => ({ type: actionTypes.NotificationsRead })
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.NotificationsRead:
      return { ...state, read: true }
    case actionTypes.NotificationsLoading:
      return { ...state, retrieving: true }
    case actionTypes.NotificationsLoadingMore:
      return { ...state, retrievingFull: true, page: action.page }
    case actionTypes.NotificationsLoaded:
      return { ...state, ...action.data, retrieving: false, read: false }
    case actionTypes.NotificationsLoadedMore:
      return { ...state, notificationsFull: [ ...state.notificationsFull, ...action.data.notifications ], userNotificationCount: action.data.userNotificationCount, retrievingFull: false }
    case actionTypes.UpdateState:
    {
      let n = state.notifications.find(x => x.id === action.id)
      let nf = state.notificationsFull.find(x => x.id === action.id)
      return {
        ...state,
        notifications: state.notifications.map(x => x !== n ? x : { ...x, state: action.state }),
        notificationsFull: state.notificationsFull.map(x => x !== nf ? x : { ...x, state: action.state }),
        widgetKey: getComponentKey()
      }
    }
    case actionTypes.NewNotification:
    {
      let existing = state.notifications.filter(n => n.id !== action.data.id)
      existing.unshift(action.data)
      return { ...state, notifications: existing, unreadCount: (state.unreadCount || 0) + 1 }
    }
    case actionTypes.NotificationsClear:
      return { ...state, page: 0, notificationsFull: [] }
    case actionTypes.Error:
      return { ...state, retrieving: false, retrievingFull: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/Notifications.js